export default __webpack_public_path__ + "static/logo-843ccec722879c8550ef67648ce1b1c7.png";